const renderName = (value: string, rowData: any) => {
  return (
    <div
      style={{
        maxWidth: '120px',
        whiteSpace: 'normal',
        wordBreak: 'break-word',
      }}
    >
      <div style={{ fontWeight: 500, color: '#1a1a1a' }}>{value}</div>
      {rowData.phoneNumber && (
        <div style={{ fontSize: '0.75rem', color: '#666', marginTop: '1px' }}>
          {rowData.phoneNumber}
        </div>
      )}
    </div>
  );
};

export default renderName;
